import { Box, ThemeProvider } from "@mui/material";
import Login from "./pages/login/login";
import kimiaTheme from "./styles/themes/theme";
import Panel from "./pages/panel/panel";
import { QueryClient, QueryClientProvider } from "react-query";
import { Switch } from "react-router";
import { PersistGate } from "zustand-persist";
import { ToastContainer } from "react-toastify";
import useAuthStore from "./store/login/useAuthStore";

// import routes from "./routes";

function App() {
  const accessToken = useAuthStore((store) => store.accessToken);
  const queryClient = new QueryClient();

  return (
    <ThemeProvider theme={kimiaTheme}>
      <QueryClientProvider client={queryClient}>
        <PersistGate>
          <ToastContainer autoClose={5000} />
          <Box className="app">{accessToken ? <Panel /> : <Login />}</Box>
        </PersistGate>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
export default App;
